import React from 'react';
import {Table, Button, Popup} from 'semantic-ui-react';


const ResourceList = ({
    equipment, activateEditRequest
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Imovina</Table.HeaderCell>
                <Table.HeaderCell>Prostorija</Table.HeaderCell>
                <Table.HeaderCell>Tip</Table.HeaderCell>
                <Table.HeaderCell>Količina</Table.HeaderCell>
                <Table.HeaderCell>Konto</Table.HeaderCell>
                <Table.HeaderCell>Inventarni broj</Table.HeaderCell>
                <Table.HeaderCell>Opis</Table.HeaderCell>


                <Table.HeaderCell></Table.HeaderCell>

            </Table.Row>
        </Table.Header>

        <Table.Body>
            {equipment.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell>{!!el.property && el.property.name}</Table.Cell>
                        <Table.Cell>{!!el.room && el.room.name}</Table.Cell>
                        <Table.Cell>{!!el.equipmentType && el.equipmentType.name}</Table.Cell>
                        <Table.Cell>{el.number} {el.unitType.abbreviation}</Table.Cell>
                        <Table.Cell> {el.accountNumber}</Table.Cell>
                        <Table.Cell>{el.inventoryNumber}</Table.Cell>
                        <Table.Cell>{el.description}</Table.Cell>



                        <Table.Cell verticalAlign="middle" className="text-center" >
                            <Popup
                                content="Izmjena"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="pencil"
                                        size="tiny"
                                        color="green"
                                        disabled
                                        onClick={() => {
                                            activateEditRequest();
                                        }}
                                    />

                                }
                            />
                            <Popup
                                content="Brisanje"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        disabled
                                        icon="close"
                                        size="tiny"
                                        color="red"
                                        onClick={() => {

                                        }}
                                    />

                                }
                            />
                        </Table.Cell>

                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>
);

export default ResourceList;



// WEBPACK FOOTER //
// ./src/views/Assets/Resources/ResourceList.js